import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';

@Component({
    selector: "icon-alert"
    ,templateUrl: "./icon.alert.component.html"
    ,styleUrls: ["./icon.alert.component.scss"]
})
export class IconAlertComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    itemColor:string = "badge-secondary";
    listAlert:any[] = [];

    constructor(){

    }

    ngOnInit() {}

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }

    @Input()
    set val(carInfo:any) {
        if(carInfo){
            // console.log("IconAlertComponent",carInfo);
            if(carInfo.dtgGpsFaultYn === "1"){
                this.listAlert.push("GPS센서 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgSpeedFaultYn === "1"){
                this.listAlert.push("속도센서 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgRpmFaultYn === "1"){
                this.listAlert.push("RPM센서 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgBrakeFaultYn === "1"){
                this.listAlert.push("브레이크센서 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgInputFaultYn === "1"){
                this.listAlert.push("센서 입력부 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgRpmOutputYn === "1"){
                this.listAlert.push("센서 출력부 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgSaveFaultYn === "1"){
                this.listAlert.push("데이터 출력부 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgCommFaultYn === "1"){
                this.listAlert.push("통신센서 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgDistFaultYn === "1"){
                this.listAlert.push("운행거리센서 이상");
                this.itemColor = "badge-danger";
            }
            if(carInfo.dtgPowerFaultYn === "1"){
                this.listAlert.push("전원센서 이상");
                this.itemColor = "badge-danger";
            }
            if(this.listAlert?.length === 0){
                this.listAlert.push("운행기록장치 정상");
                this.itemColor = "badge-secondary";
            }
        }
    }
}